/**
 * Фильтры списка сделок: хранение в sessionStorage на время сессии вкладки WebApp.
 * При уходе с /deals и возврате значения восстанавливаются; после полного перезахода в приложение — сброс.
 */
const KEY = "crm.deals.filters.v1";

export function readDealsFiltersSnapshot() {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (!s || typeof s !== "object") return null;
    return s;
  } catch {
    return null;
  }
}

export function writeDealsFiltersSnapshot(payload) {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* ignore quota / private mode */
  }
}
